import { b64_decode, getAllCookies } from 'theme-utilities';

export const getFormSubmitData = (form) => {
	const hubSpotFields = form.querySelectorAll('[data-hstype]');
	const fields = [],
		legalConsentOptions = {},
		communications = [];

	let ipAddress = '',
		goToWebinarWebinarKey = '',
		consent_element;

	hubSpotFields.forEach((elm) => {
		switch (elm.dataset.hstype) {
			case 'field': {
				if (['checkbox', 'radio'].includes(elm.type)) {
					if (elm.checked) {
						fields.push({
							objectTypeId: elm.dataset.hstypeid,
							name: elm.name,
							value: elm.value,
						});
					}
				} else if (elm.value !== '') {
					fields.push({
						objectTypeId: elm.dataset.hstypeid,
						name: elm.name,
						value: elm.value,
					});
				}
				break;
			}
			case 'communicationCheckbox':
				communications.push({
					value: elm.checked,
					subscriptionTypeId: elm.name,
					text: b64_decode(elm.dataset.hscomtext),
				});
				break;
			case 'consent':
				consent_element = elm;
				break;
			case 'goToWebinarWebinarKey':
				goToWebinarWebinarKey = elm.value;
				break;
			case 'userOrigin':
				ipAddress = b64_decode(elm.value);
				break;
		}
	});

	/**
	 * Build the legalConsentOptions object according to the API docs
	 *
	 * @link https://legacydocs.hubspot.com/docs/methods/forms/submit_form (Section: "Legal consent options")
	 */
	switch (form.dataset.legalConsentType) {
		case 'none':
			// Nothing to do add in this case
			break;
		case 'legitimate_interest': {
			const legitimateInterestOptions = {
				value: true,
				legalBasis: consent_element.dataset.legalBasis,
				text: b64_decode(consent_element.dataset.text),
			};

			const subscriptionTypeIds = consent_element.dataset.subscriptionTypeId.split(',').map(Number);
			if (subscriptionTypeIds.length === 1) {
				legitimateInterestOptions.subscriptionTypeId = subscriptionTypeIds[0];
			} else if (subscriptionTypeIds.length > 1) {
				legitimateInterestOptions.subscriptionTypeIds = subscriptionTypeIds;
			}

			legalConsentOptions.legitimateInterest = legitimateInterestOptions;
			break;
		}
		case 'implicit_consent_to_process':
		case 'explicit_consent_to_process':
			legalConsentOptions.consent = {
				consentToProcess: true,
				text: b64_decode(consent_element.dataset.text),
				communications,
			};
			break;
	}

	return hsBodyLoad(fields, legalConsentOptions, ipAddress, goToWebinarWebinarKey);
};

/**
 * Build the object with all data that is sent to HubSpot
 *
 * @link https://legacydocs.hubspot.com/docs/methods/forms/submit_form
 */
const hsBodyLoad = (fields, legalConsentOptions, ipAddress = '', goToWebinarWebinarKey = '') => {
	const cookies = getAllCookies();

	const contextOptions = {
		pageUri: document.URL,
		pageName: document.title,
	};
	'hubspotutk' in cookies && (contextOptions.hutk = cookies['hubspotutk']);
	ipAddress && (contextOptions.ipAddress = ipAddress);
	goToWebinarWebinarKey && (contextOptions.goToWebinarWebinarKey = goToWebinarWebinarKey);

	return {
		submittedAt: Date.now(),
		fields,
		context: contextOptions,
		legalConsentOptions,
	};
};
